module.exports = __webpack_public_path__ + "img/banner2.eded7764.jpg";